/** ScrollToBottomFab (06 §4.14) — appears when scrolled up; unread overlay. */
import { ChevronDown } from 'lucide-react';
import { UnreadBadge } from '../chat-list/UnreadBadge';
import styles from './ScrollToBottomFab.module.css';

interface Props {
  visible: boolean;
  unread: number;
  onClick: () => void;
}

export function ScrollToBottomFab({ visible, unread, onClick }: Props) {
  if (!visible) return null;
  return (
    <button className={styles.fab} onClick={onClick} aria-label="Scroll to bottom">
      <ChevronDown size={22} />
      {unread > 0 && (
        <span className={styles.badge}>
          <UnreadBadge count={unread} />
        </span>
      )}
    </button>
  );
}
